import React, { useEffect, useRef, useState } from 'react';
import Overlay from './components/common/Overlay';
import { EmptyProductData, ProductData, ProductMetaData, TransitionalVideo } from './interfaces/components';
import Instructions from './pages/Instructions';
import Welcome from './pages/Welcome';
// import LoadingScreen from './pages/LoadingScreen';
import TransitionVideo from './pages/TransitionVideo';
import EntranceAudio from './assets/audios/Emtramce.mp3';
import AlmondAudio from './assets/audios/Almond.mp3';
import ImmortelleAudio from './assets/audios/Immortelle.mp3';
import LavenderAudio from './assets/audios/Lavender.mp3';
import SheaAudio from './assets/audios/Shea.mp3';

const PDP = React.lazy(() => import('./pages/PDP'));
const OutOfStock = React.lazy(() => import('./pages/OutOfStock'));

const ImmortelleFactOne = React.lazy(() => import('./pages/Immortelle/ImmortelleFactOne'));
const ImmortelleFactTwo = React.lazy(() => import('./pages/Immortelle/ImmortelleFactTwo'));
const ImmortelleFactThree = React.lazy(() => import('./pages/Immortelle/ImmortelleFactThree'));
const ImmortelleFactFour = React.lazy(() => import('./pages/Immortelle/ImmortelleFactFour'));
const ImmortelleIngredient = React.lazy(() => import('./pages/Immortelle/ImmortelleIngredient'));

const LavenderFactOne = React.lazy(() => import('./pages/Lavender/LavenderFactOne'));
const LavenderFactTwo = React.lazy(() => import('./pages/Lavender/LavenderFactTwo'));
const LavenderFactThree = React.lazy(() => import('./pages/Lavender/LavenderFactThree'));
const LavenderFactFour = React.lazy(() => import('./pages/Lavender/LavenderFactFour'));
const LavenderIngredient = React.lazy(() => import('./pages/Lavender/LavenderIngredient'));

const AlmondFactOne = React.lazy(() => import('./pages/Almond/AlmondFactOne'));
const AlmondFactTwo = React.lazy(() => import('./pages/Almond/AlmondFactTwo'));
const AlmondFactThree = React.lazy(() => import('./pages/Almond/AlmondFactThree'));
const AlmondFactFour = React.lazy(() => import('./pages/Almond/AlmondFactFour'));
const AlmondIngredient = React.lazy(() => import('./pages/Almond/AlmondIngredient'));

const ButterFactOne = React.lazy(() => import('./pages/Butter/ButterFactOne'));
const ButterFactTwo = React.lazy(() => import('./pages/Butter/ButterFactTwo'));
const ButterFactThree = React.lazy(() => import('./pages/Butter/ButterFactThree'));
const ButterFactFour = React.lazy(() => import('./pages/Butter/ButterFactFour'));
const ButterFactFive = React.lazy(() => import('./pages/Butter/ButterFactFive'));
const ButterIngredient = React.lazy(() => import('./pages/Butter/ButterIngredient'));

const Congratulations = React.lazy(() => import('./pages/Congratulations'));

import useWindowDimensions from './utils/hooks/useWindowDimensions';
import Spinner from './components/common/Spinner';
import axios from 'axios';

import ImmortelleTransitionMobile from './assets/videos/ImmortelleTransitonMobile.mp4';
import ImmortelleTransitionDesktop from './assets/videos/TransitionImmortelle.mp4';
import LavanderTransitionMobile from './assets/videos/LavanderTransitionMobile.mp4';
import LavanderTransitionDesktop from './assets/videos/LavanderTransitionDesktop.mp4';
import AlmondTransitionDesktop from './assets/videos/AlmondTransition.mp4';
import AlmondTransitionMobile from './assets/videos/AlmondTransitonMobile.mp4';
import SheaTransitonDesktop from './assets/videos/TransitionShea1.mp4';
import SheaTransitonMobile from './assets/videos/TransitionSheaMobile.mp4';

import { dispatchAudioAnalytics, dispatchCollectItemAnalytics } from './Analytics';
import { ArabicIngredients } from './content';
import { Lavender } from './Icons/Lavender';
import { Immortale } from './Icons/Immortale';
import { Almond } from './Icons/Almond';
import { SheaButter } from './Icons/SheaButter';
import Toast from './components/common/Toast';
import AudioToggleModal from './pages/AudioToggleModal';
import { getBrowserName, getOpSys } from './utils/helper';

function App() {
  const { width } = useWindowDimensions();
  const [audioSrc, setAudioSrc] = useState(EntranceAudio);
  const [audioActive, setAudioActive] = useState(false);
  const firstUpdate = useRef(true);
  const audioRef = useRef<HTMLAudioElement>(null);
  const [tabVisible, setTabVisible] = useState<boolean>(true);
  const [activeLocale, setActiveLocale] = useState('');
  const [activeScene, setActiveScene] = useState('room-1');
  const [audioModal, setAudioModal] = useState(false);
  // const [loadUI, setLoadUI] = useState(false);
  const [instructionsActive, setInstructionsActive] = useState(false);
  const [welcomeActive, setWelcomeActive] = useState(true);
  const [congratulationsActive, setCongratulationsActive] = useState(false);
  const [immortelleCollected, setImmortelleCollected] = useState(false);
  const [almondCollected, setAlmondCollected] = useState(false);
  const [lavenderCollected, setLavenderCollected] = useState(false);
  const [sheaButterCollected, setSheaButterCollected] = useState(false);
  const [pdpLoading, setPdpLoading] = useState(false);

  const [immortelleFactOneActive, setImmortelleFactOneActive] = useState(false);
  const [immortelleFactTwoActive, setImmortelleFactTwoActive] = useState(false);
  const [immortelleFactThreeActive, setImmortelleFactThreeActive] = useState(false);
  const [immortelleFactFourActive, setImmortelleFactFourActive] = useState(false);
  const [immortelleIngredientActive, setImmortelleIngredientActive] = useState(false);

  const [lavenderFactOneActive, setLavenderFactOneActive] = useState(false);
  const [lavenderFactTwoActive, setLavenderFactTwoActive] = useState(false);
  const [lavenderFactThreeActive, setLavenderFactThreeActive] = useState(false);
  const [lavenderFactFourActive, setLavenderFactFourActive] = useState(false);
  const [lavenderIngredientActive, setLavenderIngredientActive] = useState(false);

  const [almondFactOneActive, setAlmondFactOneActive] = useState(false);
  const [almondFactTwoActive, setAlmondFactTwoActive] = useState(false);
  const [almondFactThreeActive, setAlmondFactThreeActive] = useState(false);
  const [almondFactFourActive, setAlmondFactFourActive] = useState(false);
  const [almondIngredientActive, setAlmondIngredientActive] = useState(false);

  const [butterFactOneActive, setButterFactOneActive] = useState(false);
  const [butterFactTwoActive, setButterFactTwoActive] = useState(false);
  const [butterFactThreeActive, setButterFactThreeActive] = useState(false);
  const [butterFactFourActive, setButterFactFourActive] = useState(false);
  const [butterFactFiveActive, setButterFactFiveActive] = useState(false);
  const [butterIngredientActive, setButterIngredientActive] = useState(false);

  const [oosActive, setOosActive] = useState(false);
  const [pdpActive, setPDPActive] = useState(false);
  const [pdpData, setPDPData] = useState<ProductData>();
  const [productMetaData, setProductMetaData] = useState<ProductMetaData>();

  const [toast, setToast] = useState<{ icon: JSX.Element; active: boolean; border: string }>({
    icon: <></>,
    active: false,
    border: '',
  });

  const [transitionVideo, setTransitionVideo] = useState<TransitionalVideo>({
    videoURL: '',
    active: false,
    gotoRoom: '',
  });

  const resetAudioToHub = () => {
    window.GotoScene('hub_6');
    setAudioSrc(EntranceAudio);
  };

  const playTransitionVideo = (videoName: string, room: string) => {
    const videoURLs = {
      immortelle: width < 770 ? ImmortelleTransitionMobile : ImmortelleTransitionDesktop,
      lavender: width < 770 ? LavanderTransitionMobile : LavanderTransitionDesktop,
      almond: width < 770 ? AlmondTransitionMobile : AlmondTransitionDesktop,
      shea: width < 770 ? SheaTransitonMobile : SheaTransitonDesktop,
    };

    setTransitionVideo({
      active: true,
      videoURL: videoURLs[videoName as keyof typeof videoURLs],
      gotoRoom: room,
    });

    //Setting Source
    let src = EntranceAudio;
    if (room === 'hub_6') {
      src = EntranceAudio;
    } else if (room === 'almond_0') {
      src = AlmondAudio;
    } else if (room === 'immortelle_0') {
      src = ImmortelleAudio;
    } else if (room === 'shea_0') {
      src = SheaAudio;
    } else if (room === 'lavender_0') {
      src = LavenderAudio;
    }
    setAudioSrc(src);
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } else {
      if (audioActive) {
        //If Audio was already playing
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.load();
          audioRef.current.play();
        }
      } else if (!audioActive) {
        //If Audio was already paused
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.load();
          // audioRef.current.play();
          // setAudioActive(true);
        }
      }
    }
  }, [audioSrc]);

  const setProductMetaDetails = (roomName: string) => {
    const orgIdMetaTag = document.querySelector('meta[name=org_id]');
    const experienceNameMetaTag = document.querySelector('meta[name=experience_name]');
    let organisationName: string | null = '';
    let experienceName: string | null = '';
    if (orgIdMetaTag) {
      organisationName = orgIdMetaTag.getAttribute('content');
    }
    if (experienceNameMetaTag) {
      experienceName = experienceNameMetaTag.getAttribute('content');
    }
    setProductMetaData({
      organisationName: organisationName,
      experienceName: experienceName,
      roomName: roomName,
      browser: getBrowserName(),
      os: getOpSys(),
    });
  };

  const openProductPopUp = (productId: string, collection: string, scene: string) => {
    console.log('Product', productId, collection);
    const roomName: string = scene.split('_')[0];
    setProductMetaDetails(roomName);
    let apiLocale = '';

    if (window.locale === 'ar-ae') {
      apiLocale = 'ar-ae';
    } else if (window.locale === 'ar-sa') {
      apiLocale = 'ar-sa';
    } else if (window.locale === 'en-sa') {
      apiLocale = 'en-sa';
    } else if (window.locale === 'en-kw') {
      apiLocale = 'en-kw';
    } else if (window.locale === 'ar-kw') {
      apiLocale = 'ar-kw';
    } else if (window.locale === 'en-qa') {
      apiLocale = 'en-qa';
    } else if (window.locale === 'ar-qa') {
      apiLocale = 'ar-qa';
    } else {
      apiLocale = 'en-ae';
    }

    if (productId !== null) {
      setPdpLoading(true);
      axios
        .get(process.env.REACT_APP_API_URL + `${apiLocale}/` + productId, {
          params: {
            'include-data': false,
          },
        })
        .then((res) => {
          console.log(res);

          const data = res.data.data as ProductData;

          if (
            window.locale === 'ar-ae' ||
            window.locale === 'ar-sa' ||
            window.locale === 'ar-qa' ||
            window.locale === 'ar-kw'
          ) {
            setPDPData({ ...data, collection: ArabicIngredients[collection as keyof typeof ArabicIngredients] });
          } else {
            setPDPData({ ...data, collection });
          }
        })
        .catch((err: unknown) => {
          console.log(err);
          setPdpLoading(false);
          setOosActive(true);
        });
    } else {
      setOosActive(true);
    }
  };

  useEffect(() => {
    if (pdpData && pdpData.title !== '') {
      setPdpLoading(false);
      setPDPActive(true);
    }
  }, [pdpData]);

  const openEducationalPopup = (name: string, number: string) => {
    if (number === 'one') {
      if (name === 'immortelle') {
        setImmortelleFactOneActive(true);
      } else if (name === 'lavender') {
        setLavenderFactOneActive(true);
      } else if (name === 'almond') {
        setAlmondFactOneActive(true);
      } else if (name === 'butter') {
        setButterFactOneActive(true);
      }
    } else if (number === 'two') {
      if (name === 'immortelle') {
        setImmortelleFactTwoActive(true);
      } else if (name === 'lavender') {
        setLavenderFactTwoActive(true);
      } else if (name === 'almond') {
        setAlmondFactTwoActive(true);
      } else if (name === 'butter') {
        setButterFactTwoActive(true);
      }
    } else if (number === 'three') {
      if (name === 'immortelle') {
        setImmortelleFactThreeActive(true);
      } else if (name === 'lavender') {
        setLavenderFactThreeActive(true);
      } else if (name === 'almond') {
        setAlmondFactThreeActive(true);
      } else if (name === 'butter') {
        setButterFactThreeActive(true);
      }
    } else if (number === 'four') {
      if (name === 'immortelle') {
        setImmortelleFactFourActive(true);
      } else if (name === 'lavender') {
        setLavenderFactFourActive(true);
      } else if (name === 'almond') {
        setAlmondFactFourActive(true);
      } else if (name === 'butter') {
        setButterFactFourActive(true);
      }
    } else if (number === 'five') {
      if (name === 'butter') {
        setButterFactFiveActive(true);
      }
    } else if (number === 'ingredient') {
      const localImmortelle = localStorage.getItem('immortalleCollected') === 'true';
      const localLavender = localStorage.getItem('lavenderCollected') === 'true';
      const localAlmond = localStorage.getItem('almondCollected') === 'true';
      const localShea = localStorage.getItem('sheaButterCollected') === 'true';

      if (name === 'immortelle') {
        setToast({
          icon: (
            <Immortale
              boxSize={[6, 8, 10, 10]}
              borderRadius="100%"
              filter="drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)"
              fill="black"
            />
          ),
          border: '#FFF736',
          active: false,
        });
        const progress = 1 + Number(localLavender) + Number(localAlmond) + Number(localShea);
        const percentage = (progress / 4) * 100;
        setImmortelleCollected(true);
        setImmortelleIngredientActive(true);
        if (localStorage.getItem('immortalleCollected') !== 'true') {
          localStorage.setItem('immortalleCollected', 'true');
          dispatchCollectItemAnalytics('Immortelle Ingredient', 'Immortelle', percentage.toString());
        }
      } else if (name === 'lavender') {
        setToast({
          icon: (
            <Lavender
              boxSize={[6, 8, 10, 10]}
              borderRadius="100%"
              filter="drop-shadow(-2px 0px 2px #E7BFFF) drop-shadow(2px 0px 4px #6C65C2)"
              fill="black"
            />
          ),
          border: '#E7BFFF',
          active: false,
        });
        const progress = Number(localImmortelle) + 1 + Number(localAlmond) + Number(localShea);
        const percentage = (progress / 4) * 100;
        setLavenderIngredientActive(true);
        setLavenderCollected(true);
        if (localStorage.getItem('lavenderCollected') !== 'true') {
          localStorage.setItem('lavenderCollected', 'true');
          dispatchCollectItemAnalytics('Lavender Ingredient', 'Lavender', percentage.toString());
        }
      } else if (name === 'almond') {
        setToast({
          icon: (
            <Almond
              boxSize={[6, 8, 10, 10]}
              borderRadius="100%"
              filter={'drop-shadow(-2px 0px 2px #A9F58F) drop-shadow(2px 0px 4px #55AB36)'}
              fill="black"
            />
          ),
          border: '#A9F58F',
          active: false,
        });
        const progress = Number(localImmortelle) + Number(localLavender) + 1 + Number(localShea);
        const percentage = (progress / 4) * 100;
        setAlmondIngredientActive(true);
        setAlmondCollected(true);
        if (localStorage.getItem('almondCollected') !== 'true') {
          localStorage.setItem('almondCollected', 'true');
          dispatchCollectItemAnalytics('Almond Ingredient', 'Almond', percentage.toString());
        }
      } else if (name === 'butter') {
        setToast({
          icon: (
            <SheaButter
              boxSize={[6, 8, 10, 10]}
              borderRadius="100%"
              filter={'drop-shadow(-2px 0px 2px #B06C36) drop-shadow(2px 0px 4px #B09155)'}
              fill="black"
            />
          ),
          border: '#B06C36',
          active: false,
        });
        const progress = Number(localImmortelle) + Number(localLavender) + Number(localAlmond) + 1;
        const percentage = (progress / 4) * 100;
        setButterIngredientActive(true);
        setSheaButterCollected(true);
        if (localStorage.getItem('sheaButterCollected') !== 'true') {
          localStorage.setItem('sheaButterCollected', 'true');
          dispatchCollectItemAnalytics('SheaButter Ingredient', 'Shea Butter', percentage.toString());
        }
      }
    }
  };

  const checkMuteBGAudio = (scene: string) => {
    const mutedScenesArray = [
      'immortelle_1',
      'immortelle_6',
      'immortelle_13',
      'lavender_22',
      'lavender_23',
      'lavender_24',
      'lavender_25',
      'shea_34',
      'shea_36',
      'shea_42',
      'shea_33',
      'almond_9',
      'almond_12',
      'almond_13',
      'almond_16',
      'almond_25',
      'almond_26',
    ];

    const muteScene = mutedScenesArray.includes(scene);

    if (muteScene) {
      if (audioRef.current) {
        dispatchAudioAnalytics(false);
        audioRef.current.pause();
        setAudioActive(false);
      }
    }
  };

  useEffect(() => {
    window.InitiateExperience && window.InitiateExperience();
    window.openProductPopUp = openProductPopUp;
    window.checkMuteBGAudio = checkMuteBGAudio;
    window.openEducationalPopup = openEducationalPopup;
    window.playTransitionVideo = playTransitionVideo;
    window.resetAudioToHub = resetAudioToHub;
  }, []);

  useEffect(() => {
    const locale = window.locale;
    if (locale === 'ar-ae' || locale === 'ar-sa' || locale === 'ar-kw' || locale === 'ar-qa') {
      setActiveLocale('ar');
    } else if (locale === 'en-ae' || locale === 'en-sa' || locale === 'en-kw' || locale === 'en-qa') {
      setActiveLocale('en');
    }

    const alreadyImmortalleCollected = localStorage.getItem('immortalleCollected') === 'true';
    const alreadyAlmondCollected = localStorage.getItem('almondCollected') === 'true';
    const alreadySheaButterCollected = localStorage.getItem('sheaButterCollected') === 'true';
    const alreadyLavenderCollected = localStorage.getItem('lavenderCollected') === 'true';

    alreadyImmortalleCollected && setImmortelleCollected(true);
    alreadyAlmondCollected && setAlmondCollected(true);
    alreadySheaButterCollected && setSheaButterCollected(true);
    alreadyLavenderCollected && setLavenderCollected(true);
  }, []);

  const checkIfAllIngredientsCollected = () => {
    const alreadyImmortalleCollected = localStorage.getItem('immortalleCollected') === 'true';
    const alreadyAlmondCollected = localStorage.getItem('almondCollected') === 'true';
    const alreadySheaButterCollected = localStorage.getItem('sheaButterCollected') === 'true';
    const alreadyLavenderCollected = localStorage.getItem('lavenderCollected') === 'true';

    console.log('alreadyImmortalleCollected', alreadyImmortalleCollected);
    console.log('alreadyAlmondCollected', alreadyAlmondCollected);
    console.log('alreadySheaButterCollected', alreadySheaButterCollected);
    console.log('alreadyLavenderCollected', alreadyLavenderCollected);

    if (
      alreadyImmortalleCollected &&
      alreadyAlmondCollected &&
      alreadySheaButterCollected &&
      alreadyLavenderCollected
    ) {
      setCongratulationsActive(true);
    }
  };

  // EventListeners
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') setTabVisible(true);
    else setTabVisible(false);
  });

  useEffect(() => {
    if (audioActive && !tabVisible) {
      if (audioRef.current) {
        dispatchAudioAnalytics(false);
        audioRef.current.pause();
        setAudioActive(false);
      }
    }
  }, [tabVisible]);

  const toggleAudio = () => {
    if (!audioActive) {
      if (audioRef.current) {
        dispatchAudioAnalytics(true);
        audioRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (audioRef.current) {
        dispatchAudioAnalytics(false);
        audioRef.current.pause();
        setAudioActive(false);
      }
    }
  };

  const playInitialAudio = (state: boolean) => {
    if (audioRef.current) audioRef.current.volume = 0.5;

    if (state) {
      if (audioRef.current) {
        audioRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
        setAudioActive(false);
      }
    }
  };

  return (
    <>
      {/* <LoadingScreen activeLocale={activeLocale} isAudioModalOpened={audioModal} setLoadUI={() => setLoadUI(true)} /> */}
      {/* Audio Popup */}
      <AudioToggleModal
        activeLocale={activeLocale}
        proceedAudio={(state: boolean) => {
          playInitialAudio(state);
          setAudioModal(false);
        }}
        active={audioModal}
      />
      <audio ref={audioRef} src={audioSrc} />

      {pdpLoading ? (
        <Spinner />
      ) : (
        <>
          <OutOfStock
            activeLocale={activeLocale}
            active={oosActive}
            setActive={(state: boolean) => setOosActive(state)}
          />
          <PDP
            activeLocale={activeLocale}
            pdpData={pdpData}
            active={pdpActive}
            productMetaData={productMetaData as ProductMetaData}
            setActive={(state) => {
              setPDPActive(state);
              setTimeout(() => {
                setPDPData(EmptyProductData);
              }, 500);
            }}
          />
        </>
      )}
      {/* {loadUI && (
        <> */}
      <Toast toastActive={toast.active} icon={toast.icon} borderColor={toast.border} activeLocale={activeLocale} />
      <Overlay
        audioActive={audioActive}
        toggleAudio={toggleAudio}
        setLocale={(locale) => {
          setActiveLocale(locale);

          if (locale === 'en') {
            window.translateCTAsOnLocaleShift('en');
            if (window.originalLocale === 'en-ae') {
              window.locale = 'en-ae';
            } else if (window.originalLocale === 'en-sa') {
              window.locale = 'en-sa';
            } else if (window.originalLocale === 'en-kw') {
              window.locale = 'en-kw';
            } else if (window.originalLocale === 'en-qa') {
              window.locale = 'en-qa';
            } else if (window.originalLocale === 'ar-ae') {
              window.locale = 'en-ae';
            } else if (window.originalLocale === 'ar-sa') {
              window.locale = 'en-sa';
            } else if (window.originalLocale === 'ar-kw') {
              window.locale = 'en-kw';
            } else if (window.originalLocale === 'ar-qa') {
              window.locale = 'en-qa';
            }
          } else if (locale === 'ar') {
            window.translateCTAsOnLocaleShift('ar');
            if (window.originalLocale === 'en-ae') {
              window.locale = 'ar-ae';
            } else if (window.originalLocale === 'en-sa') {
              window.locale = 'ar-sa';
            } else if (window.originalLocale === 'en-kw') {
              window.locale = 'ar-kw';
            } else if (window.originalLocale === 'en-qa') {
              window.locale = 'ar-qa';
            } else if (window.originalLocale === 'ar-ae') {
              window.locale = 'ar-ae';
            } else if (window.originalLocale === 'ar-sa') {
              window.locale = 'ar-sa';
            } else if (window.originalLocale === 'ar-kw') {
              window.locale = 'ar-kw';
            } else if (window.originalLocale === 'ar-qa') {
              window.locale = 'ar-qa';
            }
          }
        }}
        activeLocale={activeLocale}
        closeAllUI={() => {
          setInstructionsActive(false);
        }}
        immortalleCollected={immortelleCollected}
        almondCollected={almondCollected}
        sheaButterCollected={sheaButterCollected}
        lavenderCollected={lavenderCollected}
        audioModal={audioModal}
        setAudioModal={(state) => setAudioModal(state)}
        activeScene={activeScene}
        setActiveScene={setActiveScene}
        toggleInstructions={() => {
          setInstructionsActive(!instructionsActive);
        }}
        playTransitionVideo={playTransitionVideo}
        resetAudioToHub={resetAudioToHub}
      />
      <Instructions
        activeLocale={activeLocale}
        active={instructionsActive}
        setActive={() => {
          setInstructionsActive(false);
          setAudioModal(true);
        }}
      />
      <Welcome
        activeLocale={activeLocale}
        active={welcomeActive}
        setActive={() => {
          setWelcomeActive(false);
          setInstructionsActive(true);
        }}
      />
      {/* </>
      )} */}

      <TransitionVideo
        resetTransitionVideo={() => {
          setTransitionVideo({
            videoURL: '',
            active: false,
            gotoRoom: '',
          });
        }}
        activeLocale={activeLocale}
        room={transitionVideo.gotoRoom}
        videoURL={transitionVideo.videoURL}
        playing={transitionVideo.active}
        setPlaying={() => {
          setTransitionVideo({ ...transitionVideo, active: false });
        }}
      />

      <Congratulations
        activeLocale={activeLocale}
        active={congratulationsActive}
        setActive={() => setCongratulationsActive(false)}
      />

      <ImmortelleFactOne
        activeLocale={activeLocale}
        active={immortelleFactOneActive}
        setActive={() => setImmortelleFactOneActive(false)}
      />
      <ImmortelleFactTwo
        activeLocale={activeLocale}
        active={immortelleFactTwoActive}
        setActive={() => setImmortelleFactTwoActive(false)}
      />
      <ImmortelleFactThree
        activeLocale={activeLocale}
        active={immortelleFactThreeActive}
        setActive={() => setImmortelleFactThreeActive(false)}
      />
      <ImmortelleFactFour
        activeLocale={activeLocale}
        active={immortelleFactFourActive}
        setActive={() => setImmortelleFactFourActive(false)}
      />
      <ImmortelleIngredient
        activeLocale={activeLocale}
        active={immortelleIngredientActive}
        setActive={() => {
          setToast({ ...toast, active: true });
          setTimeout(() => {
            setToast({ ...toast, active: false });
          }, 3000);
          setImmortelleIngredientActive(false);
          checkIfAllIngredientsCollected();
        }}
      />

      <LavenderFactOne
        activeLocale={activeLocale}
        active={lavenderFactOneActive}
        setActive={() => setLavenderFactOneActive(false)}
      />
      <LavenderFactTwo
        activeLocale={activeLocale}
        active={lavenderFactTwoActive}
        setActive={() => setLavenderFactTwoActive(false)}
      />
      <LavenderFactThree
        activeLocale={activeLocale}
        active={lavenderFactThreeActive}
        setActive={() => setLavenderFactThreeActive(false)}
      />
      <LavenderFactFour
        activeLocale={activeLocale}
        active={lavenderFactFourActive}
        setActive={() => setLavenderFactFourActive(false)}
      />
      <LavenderIngredient
        activeLocale={activeLocale}
        active={lavenderIngredientActive}
        setActive={() => {
          setToast({ ...toast, active: true });
          setTimeout(() => {
            setToast({ ...toast, active: false });
          }, 3000);
          setLavenderIngredientActive(false);
          checkIfAllIngredientsCollected();
        }}
      />

      <AlmondFactOne
        activeLocale={activeLocale}
        active={almondFactOneActive}
        setActive={() => setAlmondFactOneActive(false)}
      />
      <AlmondFactTwo
        activeLocale={activeLocale}
        active={almondFactTwoActive}
        setActive={() => setAlmondFactTwoActive(false)}
      />
      <AlmondFactThree
        activeLocale={activeLocale}
        active={almondFactThreeActive}
        setActive={() => setAlmondFactThreeActive(false)}
      />
      <AlmondFactFour
        activeLocale={activeLocale}
        active={almondFactFourActive}
        setActive={() => setAlmondFactFourActive(false)}
      />
      <AlmondIngredient
        activeLocale={activeLocale}
        active={almondIngredientActive}
        setActive={() => {
          setToast({ ...toast, active: true });
          setTimeout(() => {
            setToast({ ...toast, active: false });
          }, 3000);
          setAlmondIngredientActive(false);
          checkIfAllIngredientsCollected();
        }}
      />

      <ButterFactOne
        activeLocale={activeLocale}
        active={butterFactOneActive}
        setActive={() => setButterFactOneActive(false)}
      />
      <ButterFactTwo
        activeLocale={activeLocale}
        active={butterFactTwoActive}
        setActive={() => setButterFactTwoActive(false)}
      />
      <ButterFactThree
        activeLocale={activeLocale}
        active={butterFactThreeActive}
        setActive={() => setButterFactThreeActive(false)}
      />
      <ButterFactFour
        activeLocale={activeLocale}
        active={butterFactFourActive}
        setActive={() => setButterFactFourActive(false)}
      />
      <ButterFactFive
        activeLocale={activeLocale}
        active={butterFactFiveActive}
        setActive={() => setButterFactFiveActive(false)}
      />
      <ButterIngredient
        activeLocale={activeLocale}
        active={butterIngredientActive}
        setActive={() => {
          setToast({ ...toast, active: true });
          setTimeout(() => {
            setToast({ ...toast, active: false });
          }, 3000);
          setButterIngredientActive(false);
          checkIfAllIngredientsCollected();
        }}
      />
    </>
  );
}

export default App;
